<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-6">       
    </base-header>

        <div class="row mx-1">
          <div class="col-12 col-md-5">
            <base-input label="Đơn Vị" v-model="editjob.orgName" disabled></base-input>
          </div>
          <div class="col-12 col-md-5">
            <base-input label="Nhân sự" v-model="editjob.tenant" disabled></base-input>
          </div>
          <div class="col-12 col-md-2">
            <base-input class="mb-0" label="Trạng thái" disabled>
                  <select class="form-control" v-model.number="editjob.status">
                    <option value=1>Khởi tạo</option>
                    <option value=2>Xác Nhận</option>
                    <option value=3>Từ Chối</option>
                    <option value=4>Vào Cổng</option>
                    <option value=5>Vào Lễ Tân</option>
                    <option value=6>Vào NOC</option>
                    <option value=7>Ra NOC</option>
                    <option value=8>Ra Lễ Tân</option>
                    <option value=9>Ra Cổng</option>
                  </select>
                </base-input>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>Cổng </h4>
            Duyệt Bởi: {{editjob.l1Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
              @on-open="focus"
              @on-close="blur"
              :config="config"
              class="form-control datepicker"
              v-model="editjob.in1Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58" >
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out1Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-6 col-md">
            <base-input label="Thẻ Khách" v-model="editjob.l1Id" ></base-input>
          </div>
          
          <div class="col-6 col-md">
            <base-input label="BS Xe" v-model="editjob.vehicleId" class="mb-0" ></base-input>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>Lễ Tân</h4>
            Duyệt Bởi: {{editjob.l2Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58" >
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.in2Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out2Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md">
            <base-input label="Thẻ Chức Năng" v-model="editjob.l2Id" ></base-input>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-3">
            <h4>NOC</h4>
            Duyệt Bởi: {{editjob.l3Proctor}}
          </div>
          <div class="col-12 col-md-2">
            <i>Vào</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.in3Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-2">
            <i>Ra</i>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-pickr slot-scope="{focus, blur}"
                @on-open="focus"
                @on-close="blur"
                :config="config"
                class="form-control datepicker"
                v-model="editjob.out3Date">
              </flat-pickr>
            </base-input>
          </div>
          <div class="col-12 col-md-5">
            <base-input label="Thẻ Từ" v-model="editjob.l3Id" ></base-input>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mx-1">
          <div class="col-12 col-md-6">
            <b>Nội Dung</b>
            <textarea class="form-control" id="noidung" rows="2" placeholder="Mục đích công việc" v-model="editjob.content"></textarea>
          </div>
          <div class="col-12 col-md-6">
            <b>Ghi Chú</b>
            <textarea class="form-control" id="notes" rows="2" placeholder="Ghi chú" v-model="editjob.notes"></textarea>
          </div>
        </div>
      <div class="row mx-1 mt-2 float-right">
        <base-button type="info btn-sm" @click="huy">Đóng</base-button>
        <base-button type="primary btn-sm" @click="luu">Lưu</base-button>
      </div>
  </div>
</template>
<script>
export default {
    components: {
    },
  data() {
    return {

    editjob: {},
    config: {
      enableTime:"true",
      dateFormat:"d-m-Y H:i",
      time_24hr: true

    }
    }
  },
  methods: {
    async getjob() {
      let res = await this.$http.get('/jobs/', {params:{"id":this.$route.params.jobid}})
      this.editjob = res.data[0]
    },
    async update() {
      await this.$http.post('/jobs', this.editjob)
    },
    huy() {
      this.$router.back()
    },
    luu() {
      let job = this.editjob
      if(job.in1Date) {
        job.in1Date = this.$moment(job.in1Date, "DD-MM-YYYY HH:mm")
      }
      if(job.in2Date) {
        job.in2Date = this.$moment(job.in2Date, "DD-MM-YYYY HH:mm")
      }
      if(job.in3Date) {
        job.in3Date = this.$moment(job.in3Date, "DD-MM-YYYY HH:mm")
      }
      if(job.out1Date) {
        job.out1Date = this.$moment(job.out1Date, "DD-MM-YYYY HH:mm")
      }
      if(job.out2Date) {
        job.out2Date = this.$moment(job.out2Date, "DD-MM-YYYY HH:mm")
      }
      if(job.out3Date) {
        job.out3Date = this.$moment(job.out3Date, "DD-MM-YYYY HH:mm")
      }
      this.$http.post('jobs/edit', job)
      this.$router.back()
    }
  },
  mounted() {
    this.getjob()
  }
  
}
</script>
<style>

</style>